import { ChevronDown } from "lucide-react";
import React from "react";

export default function MyDropList({
  label,
  options = [],
  value,
  onChange,
  placeholder,
  className = "",
  error,
  disabled = false,
}) {
  return (
    <div className={`w-full ${className}`}>
      {label && (
        <label className="block mb-1 text-sm font-medium text-slate-700 dark:text-slate-300">
          {label}
        </label>
      )}

      <div className="relative">
        <select
          value={value}
          disabled={disabled}
          onChange={(e) => onChange(e.target.value)}
          className={`
            w-full appearance-none rounded-4xl border
            bg-white dark:bg-slate-900
            border-slate-200 dark:border-slate-700
            px-4 py-3 pr-10
            text-sm text-slate-700 dark:text-slate-200
            outline-none transition
            focus:ring-2 focus:ring-blue-500
            disabled:opacity-50 disabled:cursor-not-allowed
          `}
        >
          {placeholder && <option value="">{placeholder}</option>}

          {options.map((item, index) => (
            <option key={index} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>

        <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500 pointer-events-none" />
      </div>

      {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
}
